var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":("mailto:i.wisdomsky@gmail.com?subject=" + _vm.subjectEncoded + "&body=" + _vm.bodyEncoded)}},[_vm._t("default",[_vm._v("i.wisdomsky@gmail.com")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }